
define(
    'jsx!components/ideas-lab/ideas-lab-tab',[
   	"jquery",
	"underscore",
	"backbone",
    "react",
    "shared/connect-to-actions",
	"shared/connect-to-stores",
    "actions/ideas-lab"
    ], 
    function ($, _, Backbone, React){
        return React.createClass({
            displayName: "IdeasLabTab",
            getDefaultProps: function ()
            {
                return {
                    "updateDefaultCheckbox": function() {},
                    "topicAreas": [],
                    "defaultAppLevel": [],
                    "updateSelectedTopicLevel": function () {},
                    "selectedTopicArea": [],
                    "selectedAppLevel": [],
                    "isAllTopicChecked": false,
                    "isAllAppChecked": false,
                    "favorites": [],
                };
            },
            getInitialState: function ()
            {  
                return {
                    isAllChecked: true,
                    isBookmarkChecked: false,

                    isTopicAreaOpen: false,
                    isAppLevelOpen: false,
                }
            },
            componentDidUpdate: function (prevProps, prevState) {
                if (prevProps.selectedAppLevel !== this.props.selectedAppLevel || 
                    prevProps.selectedTopicArea !== this.props.selectedTopicArea) {
                      if(this.props.selectedAppLevel.length === 0 && this.props.selectedTopicArea.length === 0) {
                          this.setState({
                              isAllChecked: true,
                          })
                      }  
                }
            },
            openFilterBox: function (value) {
                if (value === "topic") {
                    this.setState({
                        isTopicAreaOpen: !this.state.isTopicAreaOpen,
                    });
                }
                if (value === "application") {
                    this.setState({
                        isAppLevelOpen: !this.state.isAppLevelOpen,
                    });
                }
            },
            onFilterAllClicked: function (value) {
                if (value === "topic") {
                    if (this.props.isAllTopicChecked) {
                        this.setState({
                            isAllChecked: false,
                        })
                        this.props.updateSelectedTopicLevel([]);
                    } else {
                        var allCategoriesGuid = _.map(this.props.topicAreas, function (topic) {
                            return topic.guid;
                        });
                        this.setState({
                            isAllChecked: false,
                        })
                        this.props.updateSelectedTopicLevel(allCategoriesGuid);
                    }
                }
                if (value === "application") {
                    if (this.props.isAllAppChecked) {
                        this.setState({
                            isAllChecked: false,
                        })
                        this.props.updateSelectedAppLevel([]);
                    } else {
                        this.setState({
                            isAllChecked: false,
                        })
                        this.props.updateSelectedAppLevel(this.props.defaultAppLevel);
                    }
                }
            },
            onAllCheckClick: function () {
                if (this.props.selectedTopicArea.length > 0 || this.props.selectedAppLevel.length > 0) {
                    this.setState({
                        isAllChecked: !this.state.isAllChecked,
                    });
                    this.props.updateDefaultCheckbox("all", this.state.isAllChecked);
                }
            },
            onBookmarkedClick: function () {
                this.setState({
                    isBookmarkChecked: !this.state.isBookmarkChecked,
                });
                this.props.updateDefaultCheckbox("bookmarked", this.state.isBookmarkChecked);
            },
            onTopicClick: function (id) {
                this.setState({
                    isAllChecked: false,
                })
                this.props.updateSelectedTopicLevel(id);
            },
            onAppClick: function (value) {
                this.setState({
                    isAllChecked: false,
                })
                this.props.updateSelectedAppLevel(value)
            },
            renderCheckBox: function (condition) {
                if (condition) {
                    return "filter-checkbox icons8-checkbox-active";
                }
                else {
                    return "filter-checkbox icons8-checkbox-inactive";
                }
            },
            renderTopicArea: function ()
            {   
                var self = this;
                var markedUpCateogries = [];
                markedUpCateogries = _.map(this.props.topicAreas, function(value) {
                    return (
                        React.createElement("div", {className: "filter-text inner", id: value.canonical_name, onClick: function()  {return self.onTopicClick(value.guid);}}, 
                            React.createElement("span", {className: self.renderCheckBox(_.indexOf(self.props.selectedTopicArea, value.guid) > -1)}), 
                            React.createElement("div", null,  value.name)
                        )
                    )
                });
                var filterboxClass = "ideas-lab-filterbox";
                if (!this.state.isAppLevelOpen) {
                    filterboxClass = "ideas-lab-filterbox full";
                }
                return (
                    React.createElement("div", {className: filterboxClass}, 
                        React.createElement("div", {className: "filter-text", onClick: function()  {return this.onFilterAllClicked("topic");}.bind(this)}, 
                            React.createElement("span", {className: this.renderCheckBox(this.props.isAllTopicChecked)}), 
                            React.createElement("div", null, "All Topics")
                        ), 
                         markedUpCateogries 
                    ));
            },
            renderAppLevel: function ()
            {
                var self = this;
                markedUpCateogries = _.map(this.props.defaultAppLevel, function(value) {
                    return (
                        React.createElement("div", {className: "filter-text inner", id: value, onClick: function()  {return self.onAppClick(value);}}, 
                            React.createElement("span", {className: self.renderCheckBox(_.indexOf(self.props.selectedAppLevel, value) > -1)}), 
                            React.createElement("div", null,  value )
                        )
                    )
                });
                var filterboxClass = "ideas-lab-filterbox";
                if (!this.state.isTopicAreaOpen) {
                    filterboxClass = "ideas-lab-filterbox full";
                }
                return (
                    React.createElement("div", {className: filterboxClass}, 
                        React.createElement("div", {className: "filter-text", onClick: function()  {return this.onFilterAllClicked("application");}.bind(this)}, 
                            React.createElement("span", {className: this.renderCheckBox(this.props.isAllAppChecked)}), 
                            React.createElement("div", null, "All Grade Levels")
                        ), 
                         markedUpCateogries 
                    ));
            },
            render: function ()
            {
                var self = this;
                return (
                    React.createElement("div", {className: "ideas-lab-tabs"}, 
                        React.createElement("h3", null, "Search Filters"), 
                        React.createElement("div", {className: "checkbox-container all", onClick: this.onAllCheckClick}, 
                            React.createElement("div", {className: this.renderCheckBox(this.state.isAllChecked)}), 
                            React.createElement("div", {className: "checkbox-text"}, "All")
                        ), 
                         window.appData.user ?
                            React.createElement("div", {className: "checkbox-container bookmarked", onClick: this.onBookmarkedClick}, 
                                React.createElement("div", {className: this.renderCheckBox(this.state.isBookmarkChecked)}), 
                                React.createElement("div", {className: "checkbox-text"}, "Bookmarked ", this.props.favorites.length > 0 ? "(" + this.props.favorites.length + ")": null), 
                                React.createElement("span", {className: "favorite icons8-bookmark-active"})
                            ) : null, 
                        
                        React.createElement("div", {className: "ideas-lab-filters", onClick: function () { self.openFilterBox("topic")}}, 
                            "Filter by Topic Areas", 
                            React.createElement("span", {className: "selected-category-counter topic"},  self.props.selectedTopicArea.length), 
                            React.createElement("span", {className: this.state.isTopicAreaOpen ? "icons8-nav-up nav-dropdown" : "icons8-nav-down nav-dropdown"})
                        ), 
                         this.state.isTopicAreaOpen ? 
                            this.renderTopicArea() : null, 
                        
                        React.createElement("div", {className: "ideas-lab-filters", onClick: function () { self.openFilterBox("application")}}, 
                            "Filter by Grade Levels",  
                            React.createElement("span", {className: "selected-category-counter app"},  self.props.selectedAppLevel.length), 
                            React.createElement("span", {className: this.state.isAppLevelOpen ? "icons8-nav-up nav-dropdown" : "icons8-nav-down nav-dropdown"})
                        ), 
                         this.state.isAppLevelOpen ? 
                            this.renderAppLevel() : null
                        
                    )
                );
            }
        });
    }
);
